import { render } from "./MetadataDetailRecords.vue?vue&type=template&id=d8312ae0&ts=true"
import script from "./MetadataDetailRecords.vue?vue&type=script&lang=ts"
export * from "./MetadataDetailRecords.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__